import { useMutation } from "@tanstack/react-query";
import apiFastifyClient from "./apiFastifyClient";

interface IReqBody {
  name: string;
  phoneNumber: string;
}

export const useAddJycFreeTicketMutation = () =>
  useMutation<void, any, IReqBody>({
    mutationFn: async (data) => {
      return apiFastifyClient.post(
        `/v1/customers/campaigns/jyc-free-ticket`,
        data,
      );
    },
  });
